import { render, staticRenderFns } from "./BoxesByList.vue?vue&type=template&id=4f425039"
import script from "./BoxesByList.vue?vue&type=script&lang=js"
export * from "./BoxesByList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports